<script setup>
const props = defineProps({
  products: {
    type: Array,
    default: [],
  },
  mode: {
    type: String,
    default: "simple",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["reset"]);

function reset() {
  emit("reset");
}

const isEmpty = ref(false);
</script>

<template>
  <div>
    <!-- <div class="flex justify-center items-center h-screen" v-if="loading">
      <p-loader class="w-20 h-20"></p-loader>
    </div> -->

    <div
      v-if="products && products.length"
      class="grid gap-4 relative"
      :class="
        mode === 'simple'
          ? 'grid-cols-1'
          : 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3'
      "
    >
      <p-card v-for="product in products" :product="product" :mode="mode">
      </p-card>
      <p-product-loading v-if="loading"></p-product-loading>
    </div>

    <p-empty v-else>
      <p-button
        class="w-50 h-10 lg:h-11"
        padding="normal"
        type="secondary"
        fontSize="base"
        @click="reset"
        >Сбросить фильтры</p-button
      >
    </p-empty>
  </div>
</template>
